import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const Card = styled.div`
  padding: 16px;
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: 8px;
  width: 100%;
`;

export default Card;
